import { RegisterFlowEditors } from "./Flow/Utilities/RegisterFlowEditors";
import { RegisterExpressionRuleEditors } from "./Expressions/RegisterExpressionRuleEditors";
import { AppGlueCommonInit } from "./rule-engine-core/AppGlueInit";
import { RegisterFlowStepRunner } from "./rule-engine-core/Flow/Utilities/RegisterFlowStepRunner";
import { ClientFormStepRunner } from "./Flow/Steps/UI/ClientFormStepRunner";
import { FormStep } from "./rule-engine-core/Flow/Steps/UI/FormStep";
import { RegisterFormElements } from "./Form/registerElements";
import { RegisterRuleElements } from "./Rule/registerElements";
import { RegisterTextEditors } from "./TextMerge/Utilities/RegisterTextEditors";

export class AppGlueCoreInit {
    static wasInit: boolean = false;

    static init() {
        if (this.wasInit) return;

        this.wasInit = true;

        AppGlueCommonInit.init();

        // register flow editors
        RegisterFlowEditors.doRegistration();

        // register form runner
        RegisterFlowStepRunner(new ClientFormStepRunner(), new FormStep());

        // register expression editors
        RegisterExpressionRuleEditors.doRegistration();

        // ensure controls are registered.
        RegisterFormElements.doRegistration();

        // register rule elements
        RegisterRuleElements.doRegistration();

        RegisterTextEditors.doRegistration();
    }
}
